import PrequalOfferError from './Error';

export default PrequalOfferError;
